module.exports = __webpack_public_path__ + "img/logImage.69de2327.jpg";